export default {
  deals: [],
  isLoading: false,
  hasError: false,
  lastFetchedAt: 0
}
